import requests from './requests'
import notifications from './notifications'
import modals from './modals'
import deletePassengers from './deletePassengers'

export default { notifications, requests, modals, deletePassengers }
